import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=175bdb21&scoped=true&"
import script from "./Compass.vue?vue&type=script&lang=js&"
export * from "./Compass.vue?vue&type=script&lang=js&"
import style0 from "./Compass.vue?vue&type=style&index=0&id=175bdb21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175bdb21",
  null
  
)

export default component.exports